<!-- eslint-disable -->
<template lang="pug">
div
  div.empty-con(v-if="!liveInfo.isOnSale")
    div.empty-img
      img(:src="empty")
    p.empty-desc 不好意思，直播已下架
    p.empty-desc 请点开其他直播链接试试吧~
  .index-container(v-if="!$isMobile")
    .header
      img(:src="logo", alt="")
    .container
      .container-top
        .container-top-img
          img(:src="liveInfo.liveCoverUrl", alt="")
        .container-top-right
          p.title {{ liveInfo.liveName }}
          .live-desc
            p.live-desc-left {{ $t('直播简介') }}:
            p.live-desc-right {{ liveInfo.liveDesc }}
          .live-price(v-if="liveInfo.isCharge")
            p.live-price-con
              span.small ¥
              span.big {{liveInfo.livePrice}}
              span.desc 订阅后不支持退费
          .live-time
            .live-time-type {{ LIVE_TYPE['' + liveInfo.liveType] }}
            .live-time-list
              ul.live-list
                li.live-item.font15 {{ formatDate(liveInfo.startTime * 1000, 'hh:mm') }}
                li(
                  :class="`live-item live-item-bar font15 color${liveInfo.liveStatus}`"
                ) {{ STATUS[liveInfo.liveStatus] }}
                li.live-item.font15 {{ formatDate(liveInfo.endTime * 1000, 'hh:mm') }}
              ul.live-list
                li.live-item.font13 {{ formatDate(liveInfo.startTime * 1000, 'yyyy/MM/dd') }}
                li.live-item.font13 {{ formatDate(liveInfo.endTime * 1000, 'yyyy/MM/dd') }}
          div(style="margin-top: 15px")
            <!-- el-button.colormain(@click="dialogFormVisible = true") {{ $t('进入直播') }} -->
            el-button.colormain(v-if="+liveInfo.liveStatus !== 2" @click="enterLive") {{ $t('进入直播') }}
            el-button.colormain(v-if="isShowBack" @click="seeBack") {{ $t('查看回放') }}
  div.mobile-live(v-else)
    .mobile-img
      img(:src="liveInfo.liveCoverUrl")
    .mobile-footer(v-if="+liveInfo.liveStatus !== 2 || liveInfo.isPlayback")
      button(class="mobile-btn outbtn" v-if="+liveInfo.liveStatus === 0" @click="setDownLoad") 预约直播
      button(class="mobile-btn goumai" v-if="getGoumai()" @click="setDownLoad") {{`购买：${liveInfo.livePrice}草籽`}}
      button(class="mobile-btn primary" v-if="+liveInfo.liveStatus !== 2 && !liveInfo.isCharge" @click="enterLive") 开始学习
      button(class="mobile-btn primary" v-if="isShowBack" @click="seeBack") {{ $t('查看回放') }}
  div.download(v-if="isNeedDownload")
    div.download-con
      div.download-con-img(v-if="showTeacher")
        img(:src="teacher")
      p.download-desc(v-if="showTeacher")
        span 扫码下载芳草教育
        span.fontbold （教师版）
      .download-btn(v-if="showTeacher")
        button.openbtn(@click="openApp('teacher')") 打开教师版App
      div.download-con-img(v-if="showParent")
        img(:src="parent")
      p.download-desc(v-if="showParent")
        span 扫码下载芳草教育
        span.fontbold （家长版）
      .download-btn(v-if="showParent")
        button.openbtn(@click="openApp('parent')") 打开家长版App
  div.tabs
    index-tabs(:live-detail="liveInfo.liveDetail" :imList="imList")
  el-dialog(:visible.sync="dialogFormVisible" title="" center :width="$isMobile ? '90%' : '50%'")
    el-form(:model="form", ref="form", :rules="rules" @submit.native.prevent)
      el-form-item(label="密码：", label-width="80px")
        el-input(
          v-model="form.password",
          maxlength="4",
          clearable,
          autocomplete="off"
        )
    template#footer
      span.dialog-footer
        el-button(@click="dialogFormVisible = false") 取消
        el-button.colormain(type="primary", @click="checkCode('form')") {{ $t('开始观看') }}
  el-dialog(:visible.sync="dialogVideoVisible" :title="liveInfo.liveName" width="65%" center)
    video.video(:src="backPlayUrl" controlsList="nodownload" disablePictureInPicture controls poster="")
  el-dialog.pc(:visible.sync="pcdownload" custom-class="pc-dialog")
    div.pc-title 扫码下载APP，支付后可观看直播哦~
    ul.pc-load
      li.pc-load-item(v-if="showTeacher")
        .pc-load-item-img
          img(:src="teacher")
        p.pc-load-item-desc
          span 扫码下载
          span.fontbold （教师版）
      li.pc-load-item(v-if="showParent")
        .pc-load-item-img
          img(:src="parent")
        p.pc-load-item-desc
          span 扫码下载
          span.fontbold （家长版）
</template>

<script>
import IndexTabs from './components/indexTabs';
import logo from '@/assets/img/logolarge.png';
import parent from '@/assets/img/parents.png';
import teacher from '@/assets/img/teachers.png';
import empty from '@/assets/img/empty.png';
import { formatDate, /* getSecretKey, */ getDetail, getBackDetail, getIMReq } from '@/utils/common';
import { BASE_CONFIG } from '@/config/basic-info-config.js';
const LIVE_TYPE = {
  1: '专家直播',
  2: '课程培训',
  3: '推广培训',
  4: '网络研讨会',
  5: '探园直播',
  6: '其他直播',
};
const STATUS = {
  0: '未开始',
  1: '直播中',
  2: '直播结束',
};
export default {
  name: 'index',
  data() {
    return {
      form: {
        password: '',
      },
      logo,
      parent,
      teacher,
      formatDate,
      liveInfo: {
        isOnSale: true,
      },
      isNeedDownload: false,
      dialogFormVisible: false,
      dialogVideoVisible: false,
      backPlayUrl: '',
      rules: {
        password: [
          {
            validator(rule, value, callback) {
              const patt = /\w{4}/;
              if (!patt.test(value)) {
                callback(new Error('输入有误'));
                return;
              }
              callback();
            },
            trigger: 'blur',
          },
        ],
      },
      STATUS,
      LIVE_TYPE,
      empty,
      pcdownload: false,
      imList: [],
    };
  },
  components: {
    IndexTabs,
  },
  computed: {
    isShowBack: a => (a.liveInfo.liveStatus === 2 && a.liveInfo.isPlayback),
    showTeacher: a => a.liveInfo.toApps && a.liveInfo.toApps.includes('zeus'),
    showParent: a => a.liveInfo.toApps && a.liveInfo.toApps.includes('hermes'),
  },
  methods: {
    seeBack() {
      const { liveInfo } = this;
      if (liveInfo.isCharge || (liveInfo.livePlaybackRep.playbackPrice > 0)) {
        const name = this.$isMobile ? 'isNeedDownload' : 'pcdownload';
        this[name] = true;
        return;
      }
      if (liveInfo.isEncrypt) {
        this.dialogFormVisible = true;
        return;
      }
      this.getLiveBack({ password: '' });
    },
    async getLiveBack(data) {
      const res = await getBackDetail(data);
      if (res.code === '0000') {
        if (res.data.errorCode === '0000') {
          if (this.$isMobile) {
            const from = window.btoa(JSON.stringify({ url: encodeURIComponent(res.data.playbackUrl) }));
            const url = `${BASE_CONFIG.shareURL}/live/index.html?w=${from}`;
            window.location.href = url;
          } else {
            this.backPlayUrl = res.data.playbackUrl;
            this.dialogVideoVisible = true;
          }
          return;
        }
        this.$message.error(res.data.errorMessage);
        return;
      }
      this.$message.error(res.message);
    },
    getGoumai() {
      const { liveInfo } = this;
      if (liveInfo.liveStatus !== 2 && liveInfo.isCharge) {
        return true;
      }
      if (liveInfo.liveStatus !== 2 && !liveInfo.isCharge) {
        return false;
      }
      return liveInfo.liveStatus === 2 && liveInfo.isPlayback && (liveInfo.livePlaybackRep.livePrice > 0);
    },
    setDownLoad() {
      this.isNeedDownload = true;
    },
    openApp(from) {
      const param = `openType=liveDetails&openId=${this.liveInfo.liveId}`;
      const url = `${BASE_CONFIG.shareURL}/invite/weixin.html?source=${from}&param=${encodeURIComponent(param)}`;
      window.location.href = url;
    },
    enterLive() {
      // if (+this.liveInfo.liveStatus === 0) {
      //   this.$message.info('直播未开始');
      //   return;
      // }
      if (this.liveInfo.isCharge) {
        const name = this.$isMobile ? 'isNeedDownload' : 'pcdownload';
        this[name] = true;
        return;
      }
      if (this.liveInfo.isEncrypt) {
        this.dialogFormVisible = true;
        return;
      }
      this.$emit('handlePlayerInfo', {});
    },
    checkCode(formEl = undefined) {
      if (!formEl) return;
      const { liveInfo } = this;
      this.$refs[formEl].validate(async (valid) => {
        if (valid) {
          if (+liveInfo.liveStatus === 2) {
            this.getLiveBack(this.form);
            return;
          }
          this.dialogFormVisible = false;
          this.$refs[formEl].resetFields();
          this.$emit('handlePlayerInfo', this.form);
        } else {
          return false;
        }
      });
    },
    async getIM(liveId) {
      const res = await getIMReq(liveId);
      const { data } = res;
      if (data.code === '0000') {
        this.imList = data.data.imList;
      }
    },
  },
  async mounted() {
    const loading = this.$loading({
      lock: true,
      text: '正在加载...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.4)',
      customClass: 'loading-live',
    });
    const liveInfoRes = await getDetail();
    loading.close();
    this.liveInfo = liveInfoRes;
    if (+liveInfoRes.liveStatus === 2) {
      this.getIM(liveInfoRes.liveId);
    }
    sessionStorage.setItem('liveDesc', liveInfoRes.liveDesc);
    sessionStorage.setItem('liveName', liveInfoRes.liveName);
    this.$emit('setLiveName', liveInfoRes.liveName);
    // const app = document.getElementById('app');
    // app && (app.style.overflow = 'auto');
  },
  unmounted() {
    // const app = document.getElementById('app');
    // app && (app.style.overflow = 'hidden');
  },
};
</script>

<style lang="stylus" scoped>
p
  margin 0
  padding 0
ul,li
  list-style none
:v-deep .el-button--text
  margin-right 15px
:v-deep .el-select
  width 300px
:v-deep .el-input
  width 300px
:v-deep .dialog-footer button:first-child
  margin-right 10px
.color0
  color #58c3b1
.color1
  color #f04527
.color2
  color #686868
.font13
  font-size 13px
.font15
  font-size 15px
.live-price-con
  font-size 14px
  color #EF3004
  padding-bottom 15px
  .desc
    color #333
    padding-left 10px
.big
  font-size 32px
  font-weight bold
.pc-dialog
  background #F1FCFA!important
.pc-title
  font-size 18px
  font-weight bold
  text-align center
.pc-load
  display flex
  justify-content space-between
  align-items center
  text-align center
  padding 20px
.pc-load-item-img
  margin 0 auto
  img
    width 80%
.pc-load-item-desc
  font-size 15px
  .fontbold
    font-weight bold
.empty-con
  position fixed
  left 0
  top 0
  width 100vw
  height 100vh
  overflow hidden
  background #F1FCFA
  z-index 999
  display flex
  justify-content center
  text-align center
  flex-direction column
  .empty-img
    width 30%
    margin 0px auto 20px
    img
      width 100%
  .empty-desc
    text-align center
    font-size 16px
    line-height 1.3
    color #050505
    font-weight bold
    font-family: Microsoft YaHei
.video
  width 100%
.tabs
  padding 15px
  box-sizing border-box
.download
  position fixed
  left 0
  top 0
  width 100%
  height 100vh
  overflow hidden
  background #F1FCFA
  display flex
  justify-content center
  flex-direction column
  align-items center
  text-align center
  z-index 999
  &-desc
    font-size 15px
    color #3D4645
    .fontbold
      font-weight bold
      color #3D4645
  .openbtn
    width 50%
    border 1px solid #07A68B
    height 50px
    line-height 50px
    border-radius 60px
    background transparent
    width 100%
    margin: 15px 0
    font-size 16px
  &-con
    &-img
      width 25vh
      margin 0 auto
      img
        width 100%
        vertical-align middle
.colormain
  background #58c3b1!important
  color #fff
  padding-left 20px
  padding-right 20px
.mobile-footer
  position absolute
  left 0
  bottom 0
  width 100vw
  padding 10px 15px
  box-sizing border-box
  display flex
  justify-content center
  background #D9F4EF
  z-index 9
  .goumai
    background linear-gradient(90deg, #EF7B32, #ED4A0A)
    color #fff
    border 1px solid #EF7B32
  .outbtn
    color #07C0A1
    background transparent
    border 1px solid #07C0A1
  .primary
    color #fff
    background #07C0A1
    border 1px solid #07C0A1
  .mobile-btn
    flex 1
    height 44px
    line-height 44px
    text-align center
    margin: 0 15px
    border-radius 44px
    font-size 18px
.mobile-img
  height 30vh
  overflow hidden
  img
    width 100%
    vertical-align middle
.index-container
  width 100%
  height 100%
  color #b3b8c8
  font-family PingFangSC-Medium
  box-sizing border-box
  .header
    padding 1.2rem 3rem
    box-sizing border-box
    border-bottom 1px solid #e4e8e8
    img
      width 230px
      vertical-align middle
  .container
    padding 1.2rem 3rem
    &-top
      display flex
      &-img
        flex 0 0 30%
        padding-right 2rem
        img
          width 100%
          vertical-align middle
      &-right
        color #080808
        flex 1
        .title
          font-size 16px
          padding-bottom 10px
        .live-desc
          display flex
          font-size 14px
          padding 10px 0
          &-left
            flex 0 0 80px
            font-weight bold
        .live-time
          display flex
          height: 60px
          &-type
            flex 0 0 20%
            background #f1fcfa
            color #06b799
            text-align center
            align-self center
            height 100%
            line-height 60px
          &-list
            flex 0 0 50%
            padding 0.7rem 10px
            height 100%
            background #f3f3f3
            .live-list
              display flex
              justify-content space-between
            .live-item
              flex 0 0 20%
              text-align center
            .live-item-bar
              position relative
              z-index 12
              flex 1
              text-align center
              &:after,
              &:before
                content ""
                position: absolute
                top 12px
                width 35%
                height 0
                border-bottom 1px solid #b1b0b0
              &:after
                left 0
              &:before
                right 0
</style>
